import { render, staticRenderFns } from "./CollapseContainer.vue?vue&type=template&id=597b585e"
import script from "./CollapseContainer.vue?vue&type=script&lang=js"
export * from "./CollapseContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports